<template>
  <section class="background mb-1">
    <img
      class="img-fluid img-contact"
      src="@/assets/bg-contact.svg"
      alt="Imagem"
    />
    <div class="bg-color"></div>
    <div class="container py-5 h100">
      <div class="row justify-content-between contact pt-3">
        <div class="col-lg-7 img-hide">
          <img
            class="img-fluid img-intro-contact"
            src="@/assets/img-intro-contact.png"
            alt="Imagem"
          />
          <div class="panelsite-link">
            <span v-if="$store.getters.lang === 'en'">
              Looking to join our survey panel?
              <a target="_blank" href="https://www.queopinas.com/?locale=en_US"
                >Click here.</a
              >
            </span>
            <span v-else-if="$store.getters.lang === 'pt'">
              Quer participar do nosso painel de pesquisa?
              <a target="_blank" href="https://www.voceopina.com.br"
                >Clique aqui.</a
              ></span
            >
            <span v-else>
              ¿Buscas unirte a nuestro panel de encuestas?
              <a target="_blank" href="https://www.queopinas.com/?locale=es_US"
                >Haz click aquí.</a
              >
            </span>
          </div>
        </div>
        <div class="col-lg-5 survey">
          <div class="title pb-4">
            <p>
              {{
                $store.getters.trans
                  ? $store.getters.trans.menu_contact.get_in_touch
                  : "Get in touch!"
              }}
            </p>
          </div>

          <form @submit="applyJob" v-if="$store.getters.lang === 'en'">
            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="name"
                v-model="name"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.name
                    : 'Name'
                "
              />
            </div>
            <div class="input mb-3">
              <input
                type="email"
                class="form-control p-4"
                id="email"
                v-model="email"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.email
                    : 'E-mail'
                "
              />
            </div>
            <div class="input-2 mb-3">
              <input
                type="text"
                v-mask="'+# (###) ###-####'"
                class="form-control p-4 input input-tel"
                id="phone"
                v-model="tel"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.phone
                    : 'Phone'
                "
              />
              <select
                class="form-control custom-select-country"
                id="country"
                v-model="country"
                required
              >
                <option value="" disabled>
                  {{ "Country" }}
                </option>
                <option value="Argentina">Argentina</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Brazil">Brazil</option>
                <option value="Canada">Canada</option>
                <option value="Chile">Chile</option>
                <option value="Colombia">Colombia</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Cuba">Cuba</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="El Salvador">El Salvador</option>
                <option value="United States">United States</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Haiti">Haiti</option>
                <option value="Honduras">Honduras</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Mexico">Mexico</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Panama">Panama</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Saint Kitts and Nevis"
                  >Saint Kitts and Nevis</option
                >
                <option value="Saint Lucia">Saint Lucia</option>
                <option value="Saint Vincent and the Grenadines"
                  >Saint Vincent and the Grenadines</option
                >
                <option value="Suriname">Suriname</option>
                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Spain">Spain</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="company"
                v-model="company"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.company
                    : 'Company'
                "
              />
            </div>
            <div class="mb-5">
              <textarea
                class="form-control"
                id="msg"
                rows="5"
                v-model="msg"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.message
                    : 'Message'
                "
              ></textarea>
            </div>
            <div class="d-flex justify-content-center mb-4">
              <vue-recaptcha
                sitekey="6LftqroaAAAAALd8sznQebEoKMWzde_qSLIuJzd7"
                :loadRecaptchaScript="true"
                @verify="mxVerify"
                id="recaptcha"
              ></vue-recaptcha>
            </div>
            <div class="margin-bottom">
              <b-form-checkbox
                class="check text-input-checkbox"
                id="request_panelbook"
                v-model="request_panelbook"
                name="checkbox-1"
                value="accepted"
                unchecked-value="0"
              >
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.request_our_panel_book
                    : "Request our Panel Book"
                }}
              </b-form-checkbox>
              <button id="btn-send-en" class="btn btn-send btn_bottom">
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.send
                    : "Message"
                }}
              </button>
            </div>
          </form>

          <form @submit="applyJob" v-if="$store.getters.lang === 'es'">
            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="name"
                v-model="name"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.name
                    : 'Name'
                "
              />
            </div>
            <div class="input mb-3">
              <input
                type="email"
                class="form-control p-4"
                id="email"
                v-model="email"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.email
                    : 'E-mail'
                "
              />
            </div>
            <div class="input-2 mb-3">
              <input
                type="text"
                v-mask="'+## ####-####-####-####'"
                class="form-control p-4 input input-tel"
                id="phone"
                v-model="tel"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.phone
                    : 'Phone'
                "
              />

              <select
                class="form-control custom-select-country"
                id="country"
                v-model="country"
                required
              >
                <option value="" disabled>
                  {{ "País" }}
                </option>
                <option value="Argentina">Argentina</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Brazil">Brazil</option>
                <option value="Canada">Canada</option>
                <option value="Chile">Chile</option>
                <option value="Colombia">Colombia</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Cuba">Cuba</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="El Salvador">El Salvador</option>
                <option value="United States">United States</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Haiti">Haiti</option>
                <option value="Honduras">Honduras</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Mexico">Mexico</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Panama">Panama</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Saint Kitts and Nevis"
                  >Saint Kitts and Nevis</option
                >
                <option value="Saint Lucia">Saint Lucia</option>
                <option value="Saint Vincent and the Grenadines"
                  >Saint Vincent and the Grenadines</option
                >
                <option value="Suriname">Suriname</option>
                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Spain">Spain</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Other">Otro</option>
              </select>
            </div>

            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="company"
                v-model="company"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.company
                    : 'Company'
                "
              />
            </div>
            <div class="mb-5">
              <textarea
                class="form-control"
                id="msg"
                rows="5"
                v-model="msg"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.message
                    : 'Message'
                "
              ></textarea>
            </div>
            <div class="d-flex justify-content-center mb-4">
              <vue-recaptcha
                sitekey="6LftqroaAAAAALd8sznQebEoKMWzde_qSLIuJzd7"
                :loadRecaptchaScript="true"
                @verify="mxVerify"
                id="recaptcha"
              ></vue-recaptcha>
            </div>
            <div class="margin-bottom">
              <b-form-checkbox
                class="check text-input-checkbox"
                id="request_panelbook"
                v-model="request_panelbook"
                name="checkbox-1"
                value="accepted"
                unchecked-value="0"
              >
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.request_our_panel_book
                    : "Request our Panel Book"
                }}
              </b-form-checkbox>
              <button id="btn-send-es" class="btn btn-send btn_bottom">
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.send
                    : "Message"
                }}
              </button>
            </div>
          </form>
          <form @submit="applyJob" v-if="$store.getters.lang === 'pt'">
            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="name"
                v-model="name"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.name
                    : 'Name'
                "
              />
            </div>
            <div class="input mb-3">
              <input
                type="email"
                class="form-control p-4"
                id="email"
                v-model="email"
                required
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.email
                    : 'E-mail'
                "
              />
            </div>
            <div class="input-2 mb-3">
              <input
                type="text"
                v-mask="'+## (##) #####-####'"
                class="form-control p-4 input input-tel"
                id="phone"
                v-model="tel"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.phone
                    : 'Phone'
                "
              />
              <select
                class="form-control custom-select-country"
                id="country"
                v-model="country"
                required
              >
                <option value="" disabled>
                  {{ "País" }}
                </option>
                <option value="Argentina">Argentina</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Brazil">Brazil</option>
                <option value="Canada">Canada</option>
                <option value="Chile">Chile</option>
                <option value="Colombia">Colombia</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Cuba">Cuba</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="El Salvador">El Salvador</option>
                <option value="United States">United States</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Haiti">Haiti</option>
                <option value="Honduras">Honduras</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Mexico">Mexico</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Panama">Panama</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Saint Kitts and Nevis"
                  >Saint Kitts and Nevis</option
                >
                <option value="Saint Lucia">Saint Lucia</option>
                <option value="Saint Vincent and the Grenadines"
                  >Saint Vincent and the Grenadines</option
                >
                <option value="Suriname">Suriname</option>
                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Spain">Spain</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Other">Outro</option>
              </select>
            </div>

            <div class="input mb-3">
              <input
                type="text"
                class="form-control p-4"
                id="company"
                v-model="company"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.company
                    : 'Company'
                "
              />
            </div>
            <div class="mb-5">
              <textarea
                class="form-control"
                id="msg"
                rows="5"
                v-model="msg"
                :placeholder="
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.message
                    : 'Message'
                "
              ></textarea>
            </div>

            <div class="d-flex justify-content-center mb-4">
              <vue-recaptcha
                sitekey="6LftqroaAAAAALd8sznQebEoKMWzde_qSLIuJzd7"
                :loadRecaptchaScript="true"
                @verify="mxVerify"
                id="recaptcha"
              ></vue-recaptcha>
            </div>

            <div class="margin-bottom">
              <b-form-checkbox
                class="check text-input-checkbox"
                id="request_panelbook"
                v-model="request_panelbook"
                name="checkbox-1"
                value="accepted"
                unchecked-value="0"
              >
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.request_our_panel_book
                    : "Request our Panel Book"
                }}
              </b-form-checkbox>

              <button id="btn-send-pt" class="btn btn-send btn_bottom">
                {{
                  $store.getters.trans
                    ? $store.getters.trans.menu_contact.send
                    : "Message"
                }}
              </button>
            </div>
          </form>
          <div class="panelsite-link mobile">
            <span v-if="$store.getters.lang === 'en'">
              Looking to join our survey panel?
              <a target="_blank" href="https://www.queopinas.com/?locale=en_US"
                >Click here.</a
              >
            </span>
            <span v-else-if="$store.getters.lang === 'pt'">
              Quer participar do nosso painel de pesquisa?
              <a target="_blank" href="https://www.voceopina.com.br"
                >Clique aqui</a
              ></span
            >
            <span v-else>
              ¿Buscas unirte a nuestro panel de encuestas?
              <a target="_blank" href="https://www.queopinas.com/?locale=es_US"
                >Haz click aquí.</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <warn-popup v-if="showWarnPopup" :closeDialog="() => closeDialog()" />
  </section>
</template>

<script>
import { api } from "@/services.js";
import VueRecaptcha from "vue-recaptcha";
import WarnPopup from "./warn-popup.vue";

export default {
  components: { VueRecaptcha, WarnPopup },
  data() {
    return {
      loader: false,
      name: "",
      email: "",
      tel: "",
      country: "",
      company: "",
      msg: "",
      request_panelbook: "0",
      recaptcha: null,
      domainsValidation: ["gmail.com", "hotmail.com", "yahoo.com"],
      showWarnPopup: false
    };
  },
  methods: {
    mxVerify(response) {
      this.recaptcha = response;
    },
    closeDialog() {
      this.showWarnPopup = false;
    },
    applyJob(e) {
      e?.preventDefault();

      this.$gtag.event("conversion", {
        send_to: "AW-1072735680/U3xwCJi7is0BEMDLwv8D"
      });

      this.$gtag.event("conversion", {
        send_to: "AW-404271196/mL-hCKvXvskZENzg4sAB"
      });

      if (!this.loader && this.email !== "" && this.recaptcha !== null) {
        const emailDomain = this.email.split("@")[1];
        if (this.domainsValidation.includes(emailDomain)) {
          this.showWarnPopup = true;

          return;
        }

        const queryParams = this.$route.query;
        const params = {
          name: this.name,
          email: this.email,
          tel: this.tel,
          country: this.country,
          company: this.company,
          msg: this.msg,
          request_panelbook: this.request_panelbook,
          utm_term: sessionStorage.getItem("owsite-utm_term") || ""
        };
        if ("from" in queryParams)
          if ("to" in queryParams) {
            params.from = queryParams.from;
            params.to = queryParams.to;
          }

        this.loader = true;
        api
          .post("mail/contact", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })

          .then(r => {
            if (r.status === 200) {
              this.name = "";
              this.email = "";
              this.tel = "";
              this.country = "";
              this.company = "";
              this.msg = "";

              window.grecaptcha.reset();

              document.querySelector("#request_panelbook").checked = false;
              this.$toast.open(
                `${
                  this.$store.getters.trans
                    ? this.$store.getters.trans.menu_contact.error
                        .successfully_sent
                    : "Successfully sent!"
                }`
              );
            }
            this.loader = false;
          })
          .catch(() => {
            this.$toast.error(
              `${
                this.$store.getters.trans
                  ? this.$store.getters.trans.menu_contact.error
                      .something_went_wrong
                  : "Something went wrong!"
              }`
            );
            this.loader = false;
          });
      } else {
        this.$toast.error(
          `${
            this.$store.getters.trans
              ? this.$store.getters.trans.menu_contact.error.check_captcha
              : "Please check the captcha!"
          }`
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 78px;
}

.img-contact {
  position: absolute;
  top: 0;
  left: 40%;
  height: 100%;
}

label {
  margin-left: 0;
}

textarea.form-control {
  height: auto;
  padding: 20px 20px 20px 20px;
  border-radius: 35px;
  box-shadow: 1px 1px 2px rgba(45, 97, 135, 0.3);
}

textarea::-webkit-input-placeholder {
  color: #6b6b6b;
  font-size: 0.8rem;
}

.check {
  position: relative;
  top: calc(50% - 16px);
  font-size: 1em;
  right: -15px;
}

.custom-select-country {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  border-radius: 100px;
  position: relative;
  width: 100%;
  height: 48px;
  box-shadow: 1px 1px 2px rgba(45, 97, 135, 0.3);
  font-size: 13px;
  border: none;
  padding: 10px 15px;
  background-color: #fff;
  appearance: none;
}

.custom-select-country:focus {
  outline: none;
  border-color: #0686e0;
  box-shadow: 0 0 5px rgba(6, 134, 224, 0.5);
}

.text-input-checkbox {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  font-size: 0.8rem;
  color: #666666;
}

.input {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  border-radius: 33px;
  position: relative;
  width: 100%;
  box-shadow: 1px 1px 2px rgba(45, 97, 135, 0.3);
  font-size: 15px;
  border-radius: 100px;
  ::placeholder {
    font-size: 0.8em;
  }
}
input {
  width: 100%;
  font-size: 15px;
  border: none;
  border-radius: 33px;
}

.input-2 {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  border-radius: 33px;
  position: relative;
  width: 100%;
  font-size: 15px;
  border-radius: 100px;
  ::placeholder {
    font-size: 0.8em;
  }
}
input-2 {
  width: 100%;
  font-size: 15px;
  border: none;
  border-radius: 33px;
}

.input-message {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  border-radius: 33px;
  position: relative;
  width: 100%;
  box-shadow: 1px 1px 2px rgba(45, 97, 135, 0.3);
  font-size: 15px;
  border-radius: 100px;
  ::placeholder {
    font-size: 0.8em;
  }
}

.img-intro-contact {
  position: relative;
  padding-top: 90px;
}

@media (max-width: 1268px) {
  .background {
    background-color: #f7f9fc;
  }
}

.title {
  text-align: center;
  p {
    margin-bottom: 0;
    color: black;
    font-weight: bold;
    font-size: 30px;
  }
  h2 {
    color: 000000;
    font-weight: 500;
    font-size: 1.5rem;
  }
}

.btn-send {
  letter-spacing: 0.12em;
  text-transform: uppercase;
  position: relative;
  right: -90px;
  top: -4px;
  color: #ffffff;
  font-size: 0.8rem;
  background: #0686e0;
  box-shadow: 5px 5px 16px rgba(45, 97, 135, 0.3);
  border-radius: 100px;
  font-weight: 500;
  padding: 3px 50px 3px 50px;
  transition: all 0.3s ease;
}

.btn-send:hover {
  text-decoration: none;
  color: #ffffff;
  background: #0875ce;
}

.bg-color {
  height: 100%;
  right: 0;
  width: 35%;
  background-color: #f7f9fc;
  position: absolute;
}

.background {
  position: relative;
}

.form-control {
  border: none;
}

.input-tel {
  margin-right: 10px;
}

.input-country {
  margin-left: 10px;
}

.margin-bottom {
  margin-bottom: 55px;
  margin-left: 8px;
  display: flex;
}

npm.panelsite-link {
  display: flex;
  justify-content: center;
  padding: 2rem 0;

  span {
    display: block;
    color: #495057;
  }

  a {
    color: #0686e0;
    cursor: pointer;
    text-decoration: underline;
  }

  &.mobile {
    display: none;
    padding: 1.5rem 0;
  }
}

@media (max-width: 1199.98px) {
  .margin-bottom {
    margin-bottom: 55px;
    margin-left: 7px;
  }
  .btn-send {
    right: -40px;
  }
  .bg-color {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .img-hide {
    display: none;
  }
  .panelsite-link {
    &.mobile {
      display: flex;
    }
  }
  .title {
    margin-top: 50px;
  }
  .survey {
    text-align: center;
  }
  .margin-bottom {
    margin-bottom: 10px;
    justify-content: center;
    margin-left: -69px;
  }
  .contact {
    margin-top: 0;
  }
}

@media (max-width: 575.98px) {
  .margin-bottom {
    margin-bottom: 55px;
    margin-left: -50px;
  }
}

@media (max-width: 360px) {
  .margin-bottom {
    display: block;
  }
  .btn_bottom {
    margin-top: 20px;
    margin-right: 30px;
  }
}
</style>
